import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function toSentenceCase(str: string) {
  if (!str) return "";
  return str.replace(/-/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());
}
